import React, {
  useContext,
  useEffect,
  useRef,
  useState,
  Fragment,
} from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import {
  Row,
  Col,
  Card,
  Button,
  Checkbox,
  Form,
  Icon,
  Spin,
  Modal,
  Skeleton,
  message,
  Typography,
  Tooltip,
  Popover
} from "antd";
import { OrderConfigContext } from "../../context/OrderConfigContext";
import AppConfig from "../../config/AppConfig";
import { WarehouseContext } from "../../context/WarehouseContext";
import { UserContext } from "../../context/UserContext";
import {
  fetchConsolidatedMawbs,
  fetchOrderDetails,
  fetchOrderDetails_v2,
  fetchOrderReferences,
  pdfDataDetails,
  printOnHandReportDetails,
  printOrderDetails,
  saveOrderCall,
} from "../../api/OrdersApi";
import moment from "moment";
import { fetchUsers } from "../../api/UsersApi";
import { OrgContext } from "../../context/OrgContext";
import { catalog as fetchSlCatalog } from "../../api/ServiceLevels";
import { buildOrderTypeConfigIndex } from "../../helpers/serviceLevelDerivation";
import MoveTypeBadge from "../common/MoveTypeBadge";
import ArrowLeftIcon from "../../../assets/images/back_arrow.svg";


import ErrorComponent from "../../components/common/ErrorComponent";
import I18n from "../../common/I18n";
import {
  getColorForTitleCreateOrderScreen_v2,
  getOrderTypeIcon,
  renderNotification,
} from "../../components/orders/OrderTypeIcons";
import {
  areAppointmentsInOrder,
  formatOrderApiResponse,
  isLinehaulOrderCode,
  isMultiDayOrder,
} from "../../helpers/order_managemnt";
import ManageDetails from "../../components/orders/ManageDetails";
import OrderViewSidebar from "../../stories/components/OrderViewSidebar";
import Copyable from "../common/Copyable";
import OrderDetailsTabsInfo from "./OrderDetailsTabsInfo";
import ContextMenu from "../../stories/components/ContextMenu";
import {
  checkServiceExistance,
  renderAlertMessage,
} from "../../helpers/common";
import BaseModal from "../BaseModal";
import Dms from "../../containers/Dms";
import { alertMessage, base64ToPdf } from "../../common/Common";
import { ArrowBackIcon, CircledCloseIcon, WarehouseIcon } from "../../common/CustomIcon";
import CreateOrderScreen from "../../stories/components/CreateOrderScreen";
import ActionsForPendingOrders from "../../stories/components/ActionsForPendingOrders";
import OrderAmountSummary from "../../stories/components/OrderAmountSummary";
import StickyNote from "../orders/StickyNote";
import PdfPreviewViewer from "../../common/PdfPreviewViewer";
import { base64ToBlob } from "../../common/preview";
import OrderStatusDropdown from "../orders/OrderStatusDropdown";
import EstimateBill from "../../stories/components/orders/rightSidebar/EstimateBill";
import SplitOrderContainer from "../orders/SplitOrderContainer";
import Button_v2 from "../../stories/components/Button_v2";


const { confirm } = Modal;
const { Text } = Typography;

const ViewDetails = (props) => {
  const { form, order_id, fromIndividualScreen = false, onClose, currentPreplan, callFrom, handleSuccess, onCancel, currentRoute, backCb = null, actionType = 'view',screenFrom = "", onUnmount = () => {} } = props;
  const { getFieldDecorator, setFieldsValue } = form;
  const {
    orgSettings: organizationSettings,
    accountsExceeded,
    currentOrg,
    isAirCargo,
    currentUIVersion
  } = useContext(OrgContext);
  const { currentRole, orgRules } =  useContext(UserContext);
  const isCLIEnabled = orgRules?.org_billing_rules?.cli_order_types === 'true';
  const { orderConfig } = useContext(OrderConfigContext);

  // DB-driven order types (P6a, details header): when the org flag is on, the
  // header badge + type name come from the move-type catalog (OMT short_code /
  // display_color / alias). null => legacy icon + name switch, byte-identical.
  // Merged onto service_level_flow_enabled (2026-07-13).
  const dbOrderTypesEnabled = organizationSettings?.service_level_flow_enabled === "true";
  const [dbOrderTypeIndex, setDbOrderTypeIndex] = useState(null);
  useEffect(() => {
    if (!dbOrderTypesEnabled) return;
    let cancelled = false;
    fetchSlCatalog({ orgId: currentOrg?.id }).then((res) => {
      if (cancelled) return;
      if (res?.success) setDbOrderTypeIndex(buildOrderTypeConfigIndex(res.data));
    });
    return () => { cancelled = true; };
  }, [dbOrderTypesEnabled, currentOrg?.id]);

  const [isLoading, setIsLoading] = useState(false);
  const [refreshLhTracking, setRefreshLhTracking] = useState(false);
  const refreshLinehaulTracking = () => {
    const label = orderResponse?.order_label || orderResponse?.customer_order_details?.order_label;
    if (!isLinehaulOrderCode(label)) return;
    setRefreshLhTracking(true);
  };
  const [orderResponse, setOrderResponse] = useState({});
  const [currentProcessOrders, setCurrentProcessOrders] = useState([]);
  const [blobData, setBlobData] = useState({ blobUrl: "", fileName: "" });
  const [isOrderDownloadModalOpen, setIsOrderDownloadModalOpen] = useState(false);

  const [showBarCodeModal, setShowBarCodeModal] = useState(false);
  const [outofPreplan, setOutofPreplan] = useState(false);
  const [isModified, setIsModified] = useState(false);
  const [currentOrderId, setCurrentOrderId] = useState(order_id)
  const [activeOrderTab, setActiveOrderTab] = useState("")
  const [screenMode, setScreenMode] = useState(actionType === 'edit' ? 'full_edit' : 'view');
  const [filterWindow, setFilterWindow] = useState(false);
  const [pdfData , setPDfData]= useState({})
  const [allStatus, setAllStatus] = useState([]);
  const [consolidatedData, setConsolidatedData] = useState([]);
  const [consolidateLoading, setConsolidateLoading] = useState(false);
  const [locked, setLocked] = useState(false); 
  const [screenKey, setScreenKey] = useState(new Date().getTime());
  const [activeKey, setActiveKey] = useState('overview');
  const [showDrawer, setShowDrawer] = useState(false)
  const [viewTab, setViewTab] = useState("")
  const [estimateRefreshKey, setEstimateRefreshKey] = useState(0);
  // State for split order modal and its details
  const [showSplitOrderModal, setShowSplitOrderModal] = useState(false);
  const [splitOrderDetails, setSplitOrderDetails] = useState([]);
  const [successModalVisible, setSuccessModalVisible] = useState(false);
  const [splitOrdersPopoverVisible, setSplitOrdersPopoverVisible] = useState(false);
  //...
  const [autoOpenImportModal, setAutoOpenImportModal] = useState(false);
  // Generic update handler function to reduce repetition
  const handleUpdate = (updateType, updateData, successMessage) => {
    if (!updateData || !orderResponse) return;
    
    // Helper function to update a specific location by ID
    const updateLocationById = (locationId, updateFn) => {
      if (!locationId) return null;
      
      const updatedLocations = orderResponse.locations.map(location => 
        location.id === locationId ? updateFn(location) : location
      );
      
      return { ...orderResponse, locations: updatedLocations };
    };
    
    // Helper function to update customer order details
    const updateCustomerOrderDetails = (updates) => ({
      ...orderResponse,
      customer_order_details: {
        ...orderResponse.customer_order_details,
        ...updates
      }
    });
    
    // Helper function to update consignee details
    const updateConsigneeDetails = (updates) => ({
      ...orderResponse,
      consignee_details: {
        ...orderResponse.consignee_details,
        ...updates
      }
    });
    // Define Item details update function
    const updateItemDetails = (orderDetails = {}, itemDetails = {}) => ({
      ...orderResponse,
      customer_order_details: {
        ...orderResponse.customer_order_details,
        ...orderDetails
      },
      order_items: itemDetails.order_items,
    });

    const updateNotesDetails = (notes) => ({
      ...orderResponse,
      notes
    });

    const updateDispatchNotesDetails = (notes) => ({
      ...orderResponse,
      dispatcher_notes: notes
    });

    const updateInternalNotesDetails = (notes) => ({
      ...orderResponse,
      internal_notes: notes
    });

    const updateConsigneeNotesDetails = (notes) => ({
      ...orderResponse,
      consignee_notes: notes
    });

    // Define a map of update handlers for different update types
    const updateHandlers = {
      // Location update handler
      location: () => updateLocationById(
        updateData.id,
        location => ({ ...location, ...updateData, 
          customer_first_name: updateData.name,
          first_name: updateData.name,
          phone: updateData.phone_one, 
          phone_2: updateData.phone_two !== "MT" ? updateData.phone_two : null,
          //location_code: updateData.location_code || ''
        })
      ),
      
      // Duration update handler
      duration: () => updateLocationById(
        updateData.location_id,
        location => ({ ...location, service_duration: updateData.service_duration })
      ),
      
      // Received time update handler
      received: () => updateData.location_id ? 
        updateCustomerOrderDetails({ received_at: updateData.received_at }) : null,
      
      // Delivery by time update handler
      deliverBy: () => updateData.location_id ? 
        updateCustomerOrderDetails({ delivery_by: updateData.delivery_by }) : null,

      pickupBy: () => updateData.location_id ?
        updateCustomerOrderDetails({ pickup_by: updateData.pickup_by }) : null,

      onHand: () => updateLocationById(
        updateData.location_id,
        location => ({ ...location, on_hand_datetime: updateData.on_hand_datetime })
      ),

      outboundDock: () => updateLocationById(
        updateData.location_id,
        location => ({ ...location, outbound_dock_datetime: updateData.outbound_dock_datetime })
      ),
      
      notes: () => updateNotesDetails(updateData.notes),

      tags: () => updateCustomerOrderDetails({ tags: updateData.tags }),

      references: () => {
        const updated = updateCustomerOrderDetails(updateData.references);
        if (updateData.references?.it_number !== undefined) {
          return {
            ...updated,
            label_info: {
              ...(orderResponse.label_info || {}),
              it_number: updateData.references.it_number,
            }
          };
        }
        return updated;
      },

      optionsAndTags: () => updateCustomerOrderDetails(updateData.optionsAndTags),

      dispatchNotes: () => updateDispatchNotesDetails(updateData.dispatchNotes),

      internalNotes: () => updateInternalNotesDetails(updateData.internalNotes),

      consigneeNotes: () => updateConsigneeNotesDetails(updateData.consigneeNotes),
      
      // Appointment update handler
      appointment: () => updateLocationById(
        updateData.location_id,
        location => ({
          ...location,
          appointment: {
            appt_date: updateData.appt_date,
            start_time: updateData.start_time,
            end_time: updateData.end_time,
            slots: updateData.slots,
            confirmed: updateData.confirmed,
            has_expedite: updateData.has_expedite
          }
        })
      ),
      
      // Actual time update handler
      actual: () => updateLocationById(
        updateData.location_id,
        location => {
          const updatedLocation = { ...location };
          
          // Only update fields that are provided
          if (updateData.actual_start_datetime) {
            updatedLocation.actual_start_datetime = updateData.actual_start_datetime;
          }
          
          if (updateData.actual_end_datetime) {
            updatedLocation.actual_end_datetime = updateData.actual_end_datetime;
          }
          
          return updatedLocation;
        }
      ),
      
      // Consignee name update handler
      consigneeName: () => updateConsigneeDetails({ 
        consignee_first_name: updateData.consignee_first_name 
      }),
      
      // Consignee phone update handler
      consigneePhone: () => updateConsigneeDetails({ 
        consignee_phone_number: updateData.consignee_phone_number 
      }),
      
      // Consignee address update handler
      consigneeAddress: () => updateConsigneeDetails({
        consignee_address_line_1: updateData.consignee_address_line_1,
        consignee_address_line_2: updateData.consignee_address_line_2,
        consignee_address_zipcode: updateData.consignee_address_zipcode,
        consignee_address_city: updateData.consignee_address_city,
        consignee_address_state: updateData.consignee_address_state,
        consignee_address_country: updateData.consignee_address_country,
        consignee_address_coordinates: updateData.consignee_address_coordinates || []
      }),

      items: () => updateItemDetails({
        weight: updateData?.total_weight || 1,
        quantity: updateData?.quantity || 1,
        surface_area: updateData?.surface_area || 1,
        pallets: updateData?.pallets || 1,
        weight_uom: updateData?.weight_uom || "lbs",
        weight_in_kgs: updateData?.weight_in_kgs || 0.453592,
        dimensions_units: updateData?.dimensions_units || "in",
        mileage : updateData?.mileage ?? "",
        cbm_volume:  updateData?.cbm_volume || '',
        actual_weight: updateData?.actual_weight || 1,
        actual_weight_in_kgs: updateData?.actual_weight_in_kgs || 0.453592,        
      }, { order_items: updateData?.items || [],}),
    };
    
    // Get the handler for this update type
    const handler = updateHandlers[updateType];
    
    if (!handler) {
      console.warn(`Unknown update type: ${updateType}`, updateData);
      getOrderDetails();
      return;
    }
    
    // Execute the handler to get the updated state
    const updatedResponse = handler();
    
    // If the handler returned null, refresh the data from the server
    if (updatedResponse === null) {
      console.warn(`Missing required data for ${updateType}, refreshing order details`);
      getOrderDetails();
      return;
    }
    
    // Update the state with the new response
    setOrderResponse(updatedResponse);
    
    // Force a re-render by updating the screenKey
    setScreenKey(new Date().getTime());
    
    // Show a notification to confirm the update
    if (successMessage) {
      message.success(successMessage);
    }
  };

  // Simplified update functions that use the generic handler
  const updateLocationDetails = (locationDetails) => {
    handleUpdate('location', locationDetails);
  };
  
  const updateDurationDetails = (durationDetails) => {
    handleUpdate('duration', durationDetails, "Service duration updated successfully");
  };
  
  const updateReceivedDetails = (receivedDetails) => {
    handleUpdate('received', receivedDetails, "Received time updated successfully");
  };
  
  const updateDeliverByDetails = (deliverByDetails) => {
    handleUpdate('deliverBy', deliverByDetails, "Delivery by time updated successfully");
  };

  const updatePickupByDetails = (pickupByDetails) => {
    handleUpdate('pickupBy', pickupByDetails, "Pickup by time updated successfully");
  };

  const updateOnHandDetails = (onHandDetails) => {
    handleUpdate('onHand', onHandDetails, "On-hand time updated successfully");
    const orderLabel = orderResponse?.customer_order_details?.order_label
      || orderResponse?.order_label
      || orderResponse?.label_code;
    const location = (orderResponse?.locations || []).find(
      (loc) => String(loc?.id) === String(onHandDetails?.location_id)
    );
    if (isLinehaulOrderCode(orderLabel) && location?.type_of_loc === "PICKUP") {
      refreshLinehaulTracking();
      getOrderDetails();
    }
  };

  const updateOutboundDockDetails = (outboundDockDetails) => {
    handleUpdate('outboundDock', outboundDockDetails, I18n.t("general.outbound_dock_time") + " updated successfully");
  };
  
  const updateAppointmentDetails = (appointmentDetails) => {
    handleUpdate('appointment', appointmentDetails, I18n.t("general.appointment") + " details updated successfully");
  };
  
  const updateActualDetails = (actualDetails) => {
    handleUpdate('actual', actualDetails, "Estimated times updated successfully");
  };
  
  const updateConsigneeName = (consigneeNameDetails) => {
    handleUpdate('consigneeName', consigneeNameDetails, "Consignee name updated successfully");
  };
  
  const updateConsigneePhone = (consigneePhoneDetails) => {
    handleUpdate('consigneePhone', consigneePhoneDetails, "Consignee phone updated successfully");
  };
  
  const updateConsigneeAddress = (consigneeAddressDetails) => {
    handleUpdate('consigneeAddress', consigneeAddressDetails, "Consignee address updated successfully");
  };

  const updateItems = (itemDetails) => {
    handleUpdate('items', itemDetails, "Items Details updated successfully");
  };

   const updateNotes = (notes) => 
    handleUpdate('notes', notes, "Notes updated successfully");

  const updateTags = (tags) => 
    handleUpdate('tags', tags, "Tags updated successfully");

  const updateReferences = (references) => {
    handleUpdate('references', references, "References updated successfully");
  }

  const updateOptionsAndTags = (optionsAndTags) => { 
    handleUpdate('optionsAndTags', optionsAndTags, "Options updated successfully");
  }

  const updateDispatchNotes = (dispatchNotes) => {
    handleUpdate('dispatchNotes', dispatchNotes, "Dispatch notes updated successfully");
  };

  const updateInternalNotes = (internalNotes) => {
    handleUpdate('internalNotes', internalNotes, "Internal notes updated successfully");
  };

  const updateConsigneeNotes = (consigneeNotes) => {
    handleUpdate('consigneeNotes', consigneeNotes, "Consignee notes updated successfully");
  };

  useEffect(() => {
    if (orderResponse?.customer_order_details?.is_locked !== undefined) {
        setLocked(orderResponse.customer_order_details.is_locked === "true" || orderResponse?.is_deleted_order ? true : false);
    }
}, [orderResponse]);
  const updateView = (value) => {
    //setScreenMode(value)
    getOrderDetails(value)
  }

  useEffect(() => {
    if (screenMode === "view") {
      getOrderDetails();
    } else {
      getOrderDetails("full_edit");
    }
  }, [currentOrderId]);

  useEffect(() => {
    setCurrentOrderId(order_id);
    setOrderResponse({});
  }, [order_id]);

  useEffect(() => {
    setActiveOrderTab(
      orderResponse?.customer_order_details?.customer_order_number
    );
  }, [orderResponse]);

  // Read and clean the open_import_modal query param
  useEffect(() => {
    if (props.location?.search) {
      const params = new URLSearchParams(props.location.search);
      if (params.get("open_import_modal") === "true") {
        setAutoOpenImportModal(true);
        params.delete("open_import_modal");
        const newSearch = params.toString();
        const path = props.location.pathname + (newSearch ? `?${newSearch}` : "");
        props.history.replace(path);
      }
    }
  }, [props.location?.search, props.location?.pathname, props.history]);

  const downloadOnHandReceipt = () => {
    message.loading({
      key: "download_onHandReceipt",
      content: "Downloading PDF...",
    });

    // Process only non-PENDING and non-REJECTED orders
    const currentProcessedOrders = !["PENDING", "REJECTED"].includes(orderResponse?.status)
      ? [orderResponse]
      : [];

    if (currentProcessedOrders.length === 0) {
      message.destroy();
      renderAlertMessage(["No valid orders found to download receipt."]);
      return;
    }

    const customerOrderIds = currentProcessedOrders.map(order => order.id);

    printOnHandReportDetails(customerOrderIds).then(result => {
      message.destroy();

      if (result.success) {
        const firstOrder = currentProcessedOrders[0];
        const tempFilename = firstOrder?.hawb || firstOrder?.order_number || "order";
        const filename = `${tempFilename}_onHand_Report.pdf`;

        // Convert base64 to blob URL
        const blob = base64ToBlob(result?.data, "application/pdf");
        const blobUrl = URL.createObjectURL(blob);

        setBlobData({
          blobUrl,
          fileName: filename,
        });
      } else {
        renderAlertMessage(result.errors || ["Failed to download receipt."]);
      }
    })
  };

 
  const downloadOrderDetails = () => {
    message.loading({
      key: "download",
      content: "Downloading PDF...",
    });
    let currentProcessedOrders = !["PENDING", "REJECTED"].includes(
      orderResponse.status
    )
      ? [orderResponse]
      : [];
    const customerOrderIds = currentProcessedOrders.map((order) => order.id);
    let customerOrderHawbs = currentProcessedOrders.map((order) => order.hawb);
    if (customerOrderHawbs.filter((e) => e).length <= 0) {
      customerOrderHawbs = currentProcessedOrders.map(
        (order) => order.order_number
      );
    }
    
    let customer_order_id = customerOrderIds;
    
    const isMoveOrder = ["SDR", "SDD", "MDR", "MDD"].includes(orderResponse?.order_label)

    if(isMoveOrder){
      customer_order_id = _.compact([...customerOrderIds, orderResponse?.related_order_details?.related_order_id])
    }
    
    printOrderDetails(customer_order_id).then((result) => {
      if (result.success) {
        message.destroy();
        
        // const filename = "order_details.pdf";

        const firstOrder = currentProcessOrders[0];
        const tempFilename = firstOrder.hawb
          ? firstOrder.hawb
          : firstOrder.order_number;

        const filename = `${tempFilename}.pdf`;

        // base64ToPdf(result.orders.order_pdf, `${filename}.pdf`);

        // Convert base64 to blob URL
        const blob = base64ToBlob(result.orders.order_pdf, 'application/pdf');
        const blobUrl = URL.createObjectURL(blob);

        setBlobData({
          blobUrl: blobUrl,
          fileName: filename,
        });

        // alertMessage("PDF Downloaded Successfully", "success", 10);
      } else {
        message.destroy();
        renderAlertMessage(result.errors);
      }
    });
  };

  const getOrderDetails = (modeType = null) => {
    setIsLoading(true);

    return fetchOrderDetails_v2(currentOrderId, currentOrg?.id || "", "DISPATCHER").then(
      (result) => {
        if (result.success) {
          const data = { ...result.data };
          const orderResponse = { ...formatOrderApiResponse(data, modeType) };
          setCurrentProcessOrders([_.cloneDeep(orderResponse)]);
          setOrderResponse(orderResponse);
          setIsLoading(false)
          fetchData();
            if(modeType === "full_edit" && screenFrom === "orders"){
            const path = `/orders/${currentOrderId}/edit`;
            props.history.replace(path);
            setScreenMode(modeType)
            } else if(modeType === "view" && screenFrom == "orders"){
              const path = `/orders/${currentOrderId}/details`;
              props.history.replace(path);
              setScreenMode(modeType)
            }else{
              setScreenMode(modeType || 'view')
            }
          setScreenKey(new Date().getTime())
          return true;
        } else {
          renderAlertMessage(result.errors);
          setIsLoading(false);
          return false;
        }
      }
    ).catch((err) => {
      setIsLoading(false);
      renderAlertMessage([err?.message || I18n.t("messages.something_went_wrong")]);
      return false;
    });
  };


  const getAllStatus = (data) => {
    const allStatuses = data.map((item) => item.status);
    setAllStatus(allStatuses);
  };

  const fetchData = () => {
    setConsolidateLoading(true);
    // const orderId = _.get(orderResponse?.id, 'order_id', '');
    const payload = { order_id: currentOrderId };

    fetchConsolidatedMawbs(payload)
      .then((res) => {
        if (res.success) {
          setConsolidateLoading(false);
          const  orders = res?.data?.mawb_orders ? res.data.mawb_orders.map(rec => ({...rec, id: rec.customer_order_id})) : [];
          setConsolidatedData([...orders]);
          getAllStatus([...orders])
        } else {
          setConsolidateLoading(false);
        }
      })
      .catch((err) => {
        setConsolidateLoading(false);
        alertMessage(err.message, 'error');
      })
      .finally(() => {
        setConsolidateLoading(false);
      });
  };
  const handleStatusResult = (result) => {
    if (result.success) {
      renderNotification(I18n.t('messages.processed'), "success")
      getOrderDetails()
    } else {
      if (result.errors && result.errors.length > 0) {
        renderNotification(result.errors.join(','), "error")
      }
    }
  }

  const goToTab = (step) => {
    setActiveKey(step)
  }

  const renderOrderLabel = (orderObj) => {
    const isActive = orderObj?.customer_order_number === activeOrderTab;
    const orderLabel = orderObj?.order_label;
    const resolvedLabel = orderObj?.extra_code || orderLabel;
    // DB-driven header: catalog entry for this order's move type. null when the
    // flag is off / index not loaded / no entry (e.g. legacy extra_code variants)
    // => the legacy icon + name switch below render unchanged.
    const dbType = dbOrderTypeIndex ? dbOrderTypeIndex[resolvedLabel] : null;
    return (
      <Col
        style={{ opacity: isActive ? 1 : 0.4, cursor: !isActive && "pointer" }}
        onClick={!isActive ? () => {
          setCurrentOrderId(orderObj.related_order_id);
          // setActiveOrderTab(orderObj.customer_order_number);
        } : null}
      >
        <Row type="flex" gutter={locked ? 8 : 16}>
          <Col className="center">
            {dbType ? (
              <MoveTypeBadge
                shortCode={dbType.short_code}
                color={dbType.display_color}
                title={dbType.label}
                size={40}
              />
            ) : (
              getOrderTypeIcon(resolvedLabel, {
              width: 40,
              height: 40,
              })
            )}
          </Col>
          <Col>
            <Row>
              <Col>
                <span className="title" style={{ display: "inline-flex", alignItems: "center" }}>
                  Order{" "}
                  {orderObj?.customer_order_number
                    ? ` #${orderObj?.customer_order_number}`
                    : ""}{" "}
                  {isActive && (
                    <Copyable
                      className="orderNumberCopyIcon"
                      text={orderObj?.customer_order_number}
                    />
                  )}
                  {orderObj?.is_prepaid && (
                    <span style={{
                      display: "inline-flex",
                      alignItems: "center",
                      backgroundColor: "#fff",
                      border: "1px solid #d9d9d9",
                      borderRadius: "6px",
                      padding: "2px 6px",
                      marginLeft: "8px",
                      fontSize: "12px",
                      fontWeight: "600",
                      color: "#273156",
                      boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                      gap: "4px",
                      verticalAlign: "middle"
                    }}>
                      <Icon type="dollar" style={{ fontSize: "14px" }} />
                      Prepaid Order
                    </span>
                  )}
                </span>
              </Col>
              <Col className="sub_title">
              {dbType ? (
                <span style={{ color: "#273156" }}>
                  {dbType.label}
                </span>
              ) : (
                getColorForTitleCreateOrderScreen_v2(
                resolvedLabel,
                "#273156",
                currentOrg?.code,
                isCLIEnabled
                )
              )}
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    );
  };

  const handePDFDiagnostic = (id) => {
    pdfDataDetails(id).then((result) => {
     
      if (result.success) {
     
        if(result?.data?.response){
          const data = {
            note:"This prompt assists in diagnosing problems with orders that were originally created through the upload of a PDF file.",
            response:result?.data?.response,
            file_url:result?.data?.file_url
             }
             setPDfData(data);
          setFilterWindow(true)
        }
        
      } else {
        renderAlertMessage(result?.data?.message);
       
      }  
    });

  }

  const handleClose = (action = "", message = "", resultIsModified = false) => {
    const closableFunction = handleSuccess && typeof handleSuccess === "function" ? handleSuccess :
                      (onCancel && typeof onCancel === "function" ? onCancel : onClose)
    if (!callFrom.includes('orders')) { //['preplan', 'dispatch']
      closableFunction(
        action === "create" ? message : ((resultIsModified || isModified) ? I18n.t("messages.order_saved") : ''),
        outofPreplan,
        action === "create" ? resultIsModified : isModified ,
        orderResponse)
        onClose()
    } else {
      // closableFunction(I18n.t("messages.order_saved"), false)
      const closableFunction = onCancel && typeof onCancel === "function" ? onCancel : onClose
      closableFunction()
    }
  }

  

  const renderHeader = (orderRes) => {
    const order_lavbel_code =
      _.get(orderRes, "customer_order_details.order_label", "") || "";

    const nonPendingOrders = !["PENDING", "REJECTED"].includes(
      orderResponse.status
    )
      ? [orderResponse.id]
      : [];
    return (
      <Row className="page-header" style={{ padding: '16px', marginBottom: '0px', justifyContent: 'space-between' }}>
        <Col xs={13}>
          <Row style={{display: 'flex', alignItems: 'center'}} gutter={locked ? 10 : 16}>
            {fromIndividualScreen &&
              <Col className="order_type_icon cursorPointer center" data-testid="back-button">
                <ArrowBackIcon onClick={() => (backCb ? backCb() : props.history.push("/orders"))} />
              </Col>
            }
            {orderResponse?.related_order_details && orderResponse.related_order_details.type_of_loc == 'PICKUP' && (
              renderOrderLabel(orderRes.related_order_details)
            )}
            {renderOrderLabel(orderResponse.customer_order_details)}
            {orderResponse?.related_order_details && orderResponse.related_order_details.type_of_loc == 'DELIVERY' && (
              renderOrderLabel(orderRes.related_order_details)
            )}
          </Row>
        </Col>

        {locked && !orderResponse?.is_deleted_order &&
          <Col xs={3} style={{ paddingLeft: locked ? 10 : 0 }}>
            <span className="heading-3-large" style={{ fontWeight: "bold", fontSize: "24px", color: "#576ec1" }}>
              LOCKED
            </span>
          </Col>
        }
        <Col xs={locked ? 8: 11} className="alignRight">
          <Row type="flex" justify="end" align="middle" gutter={[16, 0]}>
            <Col className="center">
              <WarehouseIcon color='#8897A4' />
              <span className="warehouse-name">{orderRes.customer_order_details.warehouse_name}</span>
            </Col>
            {orderResponse.status === "PENDING" &&
              <Col className="center">
                <ActionsForPendingOrders
                  setIsLoading={setIsLoading}
                  handleStatusResult={handleStatusResult}
                  orderIds={[orderResponse.id]}
                />
              </Col>
            }
            {/* <Col className="center"> */}
              {/* <div className="chip">{orderResponse.status} <Icon style={{ fontSize: 12 }} type="caret-down" /> </div> */}
              {/* <OrderStatusDropdown 
                orderResponse={orderResponse} 
                getOrderDetails = {getOrderDetails} 
                currentOrg={currentOrg}
                organizationSettings={organizationSettings || {}}
              />
            </Col> */}
                { 
                !orderResponse.is_deleted_order && <Col className="center">
              <ContextMenu
                // currentProcessOrders={currentProcessOrders}
                nonPendingOrders={nonPendingOrders}
                orderResponse={orderResponse}
                onPrintClick={() => downloadOrderDetails()}
                onPrintOnHandReceipt={() => downloadOnHandReceipt()}
                showCloneButton={
                  props.showCloneButton &&
                  checkServiceExistance("SCA")
                  //&& !_.isEmpty(orders)
                }
                handleEditOrder={props.editClick}
                handleOrderclonedStatus={props.handleOrderclonedStatus}
                warehouseFilter={props.warehouseFilter}
                organizationSettings={organizationSettings}
                selectedOrders={currentProcessOrders || []}
                fromContextMenu={true}
                showPrintLables={nonPendingOrders?.length > 0}
                handleBarCodePrint={() => handleBarCodePrint(true)}
                handePDFDiagnostic={handePDFDiagnostic}
                history={props.history}
                currentOrg={currentOrg}
                refreshDetails={getOrderDetails}
                updateView={updateView}
                setIsOrderDownloadModalOpen={setIsOrderDownloadModalOpen}
                isShipper={currentRole === "shipper"}
                orgRules={orgRules}
                onOpenSplitOrder={() => onOpenSplitOrder(true)}
              />
            </Col>}
            {
              !fromIndividualScreen && <Col className="cursorPointer center">
                <CircledCloseIcon
                  color="#576EC1"
                  width="55px"
                  height="55px"
                  onClick={() => {
                    handleClose()
                  }}
                  style={{ cursor: "pointer", width: '90%'}}
                />
              </Col>}
          </Row>
        </Col>
      </Row>
    );
  };

  const renderWarningMessage = (val) => {
    if (val && ['preplan', 'dispatch'].includes(callFrom) && !outofPreplan) {
      const dialogContent = `This order will be deleted from this ${callFrom === "preplan" ? "preplan" : "route"}`;
      renderNotification(dialogContent, 'error')
    }
  }

  const renderTabs = () => {
    const isShipper = currentRole === "shipper";
    return (
      <OrderDetailsTabsInfo
        orderResponse={orderResponse}
        currentOrg={currentOrg}
        organizationSettings={organizationSettings}
        isShipper={isShipper}
        isMilitaryTime={organizationSettings?.is_military_time == "true"}
        refreshDetails={getOrderDetails}
        updateLocationDetails={updateLocationDetails}
        updateDurationDetails={updateDurationDetails}
        updateReceivedDetails={updateReceivedDetails}
        updateDeliverByDetails={updateDeliverByDetails}
        updatePickupByDetails={updatePickupByDetails}
        updateOnHandDetails={updateOnHandDetails}
        updateOutboundDockDetails={updateOutboundDockDetails}
        updateAppointmentDetails={updateAppointmentDetails}
        updateActualDetails={updateActualDetails}
        updateConsigneeName={updateConsigneeName}
        updateConsigneePhone={updateConsigneePhone}
        updateConsigneeAddress={updateConsigneeAddress}
        updateItemDetails={updateItems}
        currentPreplan={currentPreplan}
        setOutofPreplan={(val) => {
          renderWarningMessage(val)
          setOutofPreplan(val)
        }}
        setIsModified={setIsModified}
        currentRoute={currentRoute}
        consolidatedData={consolidatedData}
        activeKey={activeKey}
        setActiveKey={setActiveKey}
        goToTab={goToTab}
        setIsOrderDownloadModalOpen={setIsOrderDownloadModalOpen}
        setBlobData={setBlobData}
        setEstimateRefreshKey={(key) => setEstimateRefreshKey(key)}
        screenFrom={screenFrom}
        refreshLhTracking={refreshLhTracking}
        onLhTrackingRefreshed={() => setRefreshLhTracking(false)}
        onLinehaulTrackingRefresh={refreshLinehaulTracking}
      />
    );
  };

  const handleBarCodePrint = (visible) => {
    setShowBarCodeModal(visible);
  };

  const onOpenSplitOrder = (visible) =>{
    setShowSplitOrderModal(visible)
  }

  const handleOrderClick = orderId => {
    const path = `/orders/${orderId}/details`;
    props.history.replace(path);
  };

  const handleSuccessModalClose = () => {
    setSuccessModalVisible(false);
    getOrderDetails();
  };

  const renderSplitOrderDetails = () => {
    return (
      <Row style={{ alignItems: "center", background: '#e6ebf0', padding: "0px 16px 0px 16px" }}>
        {orderResponse?.customer_order_details?.is_split_order === true && (
          <Col style={{ flexShrink: 0 }}>
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
                background: "#eeeffe",
                border: "0.5px solid #afa9ec",
                borderRadius: 4,
                padding: "3px 8px",
                cursor: "default",
                whiteSpace: "nowrap",
              }}
            >
              <Icon type="apartment" style={{ fontSize: 14, color: "#534AB7" }} />
              <span style={{ fontSize: 12, fontWeight: 500, color: "#534AB7" }}>
                Split Order
              </span>
              {orderResponse?.customer_order_details?.parent_order_number && (
                <>
                  <span style={{ fontSize: 12, color: "#534AB7", opacity: 0.5 }}>·</span>
                  <span style={{ fontSize: 12, color: "#534AB7" }}>
                    Parent:{" "}
                    <span
                      onClick={() =>
                        orderResponse?.customer_order_details?.parent_order_id &&
                        handleOrderClick(orderResponse.customer_order_details.parent_order_id)
                      }
                      style={{
                        fontSize: 12,
                        fontWeight: 500,
                        color: "#534AB7",
                        cursor: "pointer",
                        textDecoration: "underline",
                        textDecorationStyle: "dotted",
                      }}
                    >
                      #{orderResponse.customer_order_details.parent_order_number}&nbsp;
                      <Copyable
                        className="orderNumberCopyIcon"
                        text={orderResponse.customer_order_details.parent_order_number}
                      />
                    </span>
                  </span>
                </>
              )}
            </div>
          </Col>
        )}

        {!orderResponse?.customer_order_details?.is_split_order &&
          orderResponse?.split_orders?.length > 0 && (
            <Col style={{ flexShrink: 0 }}>
              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 6,
                  background: "#eeeffe",
                  border: "0.5px solid #afa9ec",
                  borderRadius: 4,
                  padding: "3px 10px",
                  whiteSpace: "nowrap",
                }}
              >
                <Icon type="apartment" style={{ fontSize: 14, color: "#534AB7" }} />
                <span style={{ fontSize: 12, fontWeight: 500, color: "#534AB7" }}>
                  {orderResponse.split_orders.length} Split Order
                  {orderResponse.split_orders.length > 1 ? "s" : ""}:
                </span>

                {orderResponse.split_orders
                  .slice(0, orderResponse.split_orders.length <= 4 ? undefined : 3)
                  .map((order, idx, arr) => (
                    <span
                      key={order.id}
                      style={{ display: "inline-flex", alignItems: "center", gap: 0 }}
                    >
                      <Tooltip title={`Go to #${order.customer_order_number}`}>
                        <span
                          onClick={() => handleOrderClick(order.id)}
                          style={{
                            fontSize: 12,
                            fontWeight: 500,
                            color: "#534AB7",
                            cursor: "pointer",
                            textDecoration: "underline",
                            textDecorationStyle: "dotted",
                          }}
                        >
                          #{order.customer_order_number}&nbsp;
                          <Copyable
                            className="orderNumberCopyIcon"
                            text={order.customer_order_number}
                          />
                        </span>
                      </Tooltip>
                      {idx < arr.length - 1 && (
                        <span
                          style={{
                            fontSize: 12,
                            color: "#534AB7",
                            opacity: 0.5,
                            margin: "0 3px",
                          }}
                        >
                          ,
                        </span>
                      )}
                    </span>
                  ))}

                {orderResponse.split_orders.length > 4 && (
                  <>
                    <span
                      style={{ fontSize: 12, color: "#534AB7", opacity: 0.5, margin: "0 2px" }}
                    >
                      ·
                    </span>
                    <Popover
                      trigger="click"
                      placement="bottomLeft"
                      visible={splitOrdersPopoverVisible}
                      onVisibleChange={setSplitOrdersPopoverVisible}
                      getPopupContainer={() => document.body}
                      title={
                        <span style={{ color: "#534AB7", fontWeight: 600 }}>
                          All {orderResponse.split_orders.length} Split Orders
                        </span>
                      }
                      content={
                        <div style={{ maxHeight: 240, overflowY: "auto", minWidth: 165 }}>
                          {orderResponse.split_orders.map((order, idx) => (
                            <div
                              key={order.id}
                              onClick={() => handleOrderClick(order.id)}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 8,
                                padding: "6px 4px",
                                borderBottom:
                                  idx < orderResponse.split_orders.length - 1
                                    ? "1px solid #eeeffe"
                                    : "none",
                                cursor: "pointer",
                              }}
                              onMouseEnter={(e) => (e.currentTarget.style.background = "#eeeffe")}
                              onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                            >
                              <Icon type="apartment" style={{ fontSize: 12, color: "#534AB7" }} />
                              <span style={{ fontSize: 12, fontWeight: 500, color: "#534AB7" }}>
                                #{order.customer_order_number} &nbsp;
                                <Copyable
                                  className="orderNumberCopyIcon"
                                  text={order.customer_order_number}
                                />
                              </span>
                              <Icon
                                type="arrow-right"
                                style={{ fontSize: 10, color: "#534AB7", marginLeft: "auto" }}
                              />
                            </div>
                          ))}
                        </div>
                      }
                    >
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 4,
                          background: "#534AB7",
                          borderRadius: 3,
                          padding: "1px 8px",
                          cursor: "pointer",
                        }}
                      >
                        <span style={{ fontSize: 12, fontWeight: 600, color: "#fff" }}>
                          +{orderResponse.split_orders.length - 3} more
                        </span>
                        <Icon type="down" style={{ fontSize: 10, color: "#fff" }} />
                      </span>
                    </Popover>
                  </>
                )}
              </div>
            </Col>
          )}
      </Row>
    );
  };

  const renderSplitSuccessModal = () => {

    return (
      <Modal
        title={
          <span>
            <span style={{ color: "#52c41a", marginRight: 8 }}>✓</span>
            Split Order Created Successfully
          </span>
        }
        visible={successModalVisible}
        onCancel={handleSuccessModalClose}
        footer={
          <Button_v2
              className="small-btn raised"
              text="Close"
              onClick={handleSuccessModalClose}
            />
        }
        width={500}
      >
        <div style={{ padding: "8px 0" }}>
          <Text type="secondary" style={{ display: "block", marginBottom: 16 }}>
            The following orders have been created. <br/>
            Click an order number to view its details.
          </Text>

          {splitOrderDetails.map((detail, index) => (
            <div
              key={index}
              style={{
                border: "1px solid #e8e8e8",
                borderRadius: 6,
                padding: "12px 16px",
                marginBottom: index < splitOrderDetails.length - 1 ? 12 : 0,
                background: "#fafafa",
              }}
            >
            <Row type="flex" align="middle">
              {/* Source Order */}
              <Col span={11}>
                <div>
                  <Text type="secondary">Source Order</Text>
                </div>

                <div style={{ marginTop: 4 }}>
                  <Button
                    type="link"
                    style={{ padding: 0, fontWeight: 600 }}
                    onClick={() => handleOrderClick(detail.source_order_id)}
                  >
                    <span
                      style={{
                        textDecoration: "underline",
                        textDecorationStyle: "dotted",
                      }}
                    >
                      #{detail.source_order_number}
                    </span>
                  </Button>
                  &nbsp;
                  <Copyable
                    className="orderNumberCopyIcon"
                    text={detail.source_order_number}
                  />
                </div>
              </Col>

              {/* Arrow */}
              <Col span={2} style={{ textAlign: "center" }}>
                <Text style={{ color: "#bfbfbf", fontSize: 20 }}>→</Text>
              </Col>

              {/* New Split Order */}
              <Col span={11} style={{ textAlign: "right" }}>
                <div>
                  <Text type="secondary">New Split Order</Text>
                </div>

                <div style={{ marginTop: 4 }}>
                  <Button
                    type="link"
                    style={{
                      padding: 0,
                      fontWeight: 600,
                      color: "#52c41a",
                    }}
                    onClick={() => handleOrderClick(detail.cloned_order_id)}
                  >
                    <span
                      style={{
                        textDecoration: "underline",
                        textDecorationStyle: "dotted",
                      }}
                    >
                      #{detail.cloned_order_no}
                    </span>
                  </Button>
                  &nbsp;
                  <Copyable
                    className="orderNumberCopyIcon"
                    text={detail.cloned_order_no}
                  />
                </div>
              </Col>
            </Row>
            </div>
          ))}
        </div>
      </Modal>
    );
  }

  const renderSplitOrderModal = () => {

    return (
      <BaseModal
        title={"Split Order"}
        placement="right"
        closable
        onCancel={() => setShowSplitOrderModal(false)}
        visible={showSplitOrderModal}
        width={orderResponse?.order_items?.length ? "70%" : "50%"}
        style={{ top: 35 }}
        maskClosable={false}
      >
        <div>
          <SplitOrderContainer
            onCancel={() => setShowSplitOrderModal(false)}
            currentOrder={orderResponse}
            onSplitSuccess={(orderDetails) => {
              setSplitOrderDetails(orderDetails); 
              setSuccessModalVisible(true);       
              setShowSplitOrderModal(false);                         
            }}
          />
        </div>
      </BaseModal>
    );
  }

  const renderBarCodeModal = () => {
    const nonPendingOrders = currentProcessOrders.filter(
      (order) => !["REJECTED"].includes(order.status)
    );
    return (
      <BaseModal
        title={"Print Barcodes"}
        placement="right"
        closable
        onCancel={() => setShowBarCodeModal(false)}
        visible={showBarCodeModal}
        width="70%"
        style={{ top: 35 }}
        maskClosable={false}
      >
        <div className="smallTable">
          <Dms
            selectedOrders={nonPendingOrders}
            org_id={currentOrg?.id || ""}
            handleBarCodePrint={() => setShowBarCodeModal(false)}
          />
        </div>
      </BaseModal>
    );
  };

  const order_lavbel_code =
    _.get(orderResponse, "customer_order_details.order_label", "") || "";

  const handleCreateClose = () => {
    // setScreenMode('view')
    updateView('view')
  }

  return (
    <Spin spinning={isLoading}>
      {!orderResponse?.id ? (
        <Skeleton />
      ) : (
        <Row
          style={{ height: screenMode === 'view' ? "100%" : "100vh", width: "100%", overflow: "hidden" }}
          type="flex"
        >
          <Col
            style={{
              flex: 1,
              height: "calc(100vh - 88px)",
              // overflowY: "auto",
              width: "calc(100% - 256px)",
              //  padding: "16px",
              paddingTop: 0,
              paddingBottom: "100px",
            }}
            className="hide-scrollbar"
          >
            <div className="content-outer routes-classes v2_details">
              <div className="content" style={{ padding: 0 }}>
                {
                  screenMode === 'view' ? <Fragment>
                    {renderHeader(orderResponse)}
                    {filterWindow && (
                      <StickyNote
                        title="PDF Diagnostic"
                        onClose={() => setFilterWindow(false)}
                        className="sticky-note"
                        position={{ x: 750, y: 0 }}
                        info={pdfData}
                      >
                       
                    
                        
                      </StickyNote>
                    )}
                    <div>
                    {renderSplitOrderDetails()}
                    </div>
                    <OrderAmountSummary orderResponse={orderResponse} account={orderResponse.account} history={props.history} refreshDetails={getOrderDetails} 
                    showDrawer={showDrawer} setShowDrawer={(value)=> {
                      if(!value){
                        setEstimateRefreshKey(new Date().getTime())
                      }
                      setShowDrawer(value)
                    }} viewTab={viewTab} setViewTab={setViewTab}  isShipper={currentRole === "shipper"} />
                    {renderTabs()}
                  </Fragment> :
                    <CreateOrderScreen 
                      getOrderDetails={getOrderDetails}
                      orderResponse={orderResponse} 
                      backCb={handleCreateClose} 
                      screenMode={screenMode} 
                      currentPreplan={currentPreplan}
                      setOutofPreplan={(val) => {
                        renderWarningMessage(val)
                        setOutofPreplan(val)
                      }}
                      setIsModified={setIsModified}
                      currentRoute={currentRoute}
                      handleClose={handleClose}
                      callFrom={callFrom}
                      setScreenMode={() => getOrderDetails()}
                      actionType={actionType}
                      key={screenKey}
                      screenFrom={screenFrom}
                      orgRules={orgRules}
                    />
                }

              </div>
            </div>
          </Col>
          {screenMode === 'view' && 
          <>
          <Col
            data-testid="order-view-sidebar"
            style={{ width: 256, padding: "24px 16px", background: "white" }}
          >
            <OrderViewSidebar
              currentOrder={orderResponse}
              currentOrg={currentOrg}
              consolidatedData={consolidatedData}
              setActiveKey={setActiveKey}
              orderResponse={orderResponse}
              refreshDetails={getOrderDetails}
              organizationSettings={organizationSettings || {}}
              setViewTab={setViewTab} 
              goToTab={goToTab} 
              setShowDrawer={setShowDrawer}
              showDrawer={showDrawer}
              viewTab={viewTab}
              isShipper={currentRole === "shipper"}
              estimateRefreshKey={estimateRefreshKey}
              setEstimateRefreshKey={setEstimateRefreshKey}
              orgRules={orgRules}
              updateNotes={updateNotes}
              updateTags={updateTags}
              updateReferences={updateReferences}
              updateOptionsAndTags={updateOptionsAndTags}
              updateDispatchNotes={updateDispatchNotes}
              updateInternalNotes={updateInternalNotes}
              updateConsigneeNotes={updateConsigneeNotes}
              onUnmount={onUnmount}
              autoOpenImportModal={autoOpenImportModal}
              onImportModalOpened={() => setAutoOpenImportModal(false)}
              onLinehaulTrackingRefresh={refreshLinehaulTracking}
            />
          </Col>
          </>
          }
        </Row>
      )}
      {showBarCodeModal && renderBarCodeModal()}
      {showSplitOrderModal && renderSplitOrderModal()}
      {successModalVisible && renderSplitSuccessModal()}
      {isOrderDownloadModalOpen &&  <PdfPreviewViewer blobUrl={blobData.blobUrl} fileName={blobData.fileName} />}
    </Spin>
  );
};


ViewDetails.propTypes = {
  currentPreplan: PropTypes.shape(),
  currentRoute: PropTypes.shape(),
  onClose: PropTypes.func,
  onCancel: PropTypes.func,
  callFrom: PropTypes.string,
  showCloneButton: PropTypes.string,
  screenFrom: PropTypes.string,
  onUnmount: PropTypes.func,
};
ViewDetails.defaultProps = {
  currentPreplan: {},
  currentRoute: {},
  onClose: () => { },
  callFrom: "orders",
  showCloneButton:"true",
  screenFrom: "orders",
  onUnmount: () => { },
};



export default withRouter(Form.create()(ViewDetails));
